import type { MonospaceCollectionMeta, MonospaceSerializedCollection } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const Collection = withItemType<MonospaceSerializedCollection>().defineCollection({
	name: 'MonospaceCollection',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		defaultFields: ['id', 'dbName', 'apiName', 'queryCapabilities', 'isSystem', 'sourceId', 'namespaceId'],
	},
});

export const CollectionMeta = withItemType<MonospaceCollectionMeta>().defineCollection({
	name: 'MonospaceCollectionMeta',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.collectionId,
	meta: {
		defaultFields: ['collectionId', 'displayTemplate', 'displayName', 'description', 'icon', 'isHidden', 'color'],
		connect: {
			collectionId: ['collection', 'id'],
		},
	},
});
